module.exports = __webpack_public_path__ + "img/house.812b625d.svg";